import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ModuleTypes } from "@/store/ModuleTypes";
import router from "@/router";
import { Routes } from "@/router/Routes";
@Module({ namespaced: true, name: ModuleTypes.CHAT })
export default class ChatModule extends VuexModule {
  newDmOrgId: string | null = null;
  newDmUserIds: string[] = [];
  chatWithTeamId: string | null = null;
  playerId: string | null = null;

  get getChatWithTeamId() {
    return this.chatWithTeamId;
  }

  get getPlayerId() {
    return this.playerId;
  }

  get getNewDmOrgId() {
    return this.newDmOrgId;
  }
  get getNewDmUserIds() {
    return this.newDmUserIds;
  }

  @Mutation
  setPlayerId(playerId: string | null) {
    this.playerId = playerId;
  }

  @Mutation
  setChatWithTeamId(teamId: string) {
    this.chatWithTeamId = teamId;
  }

  @Mutation
  setNewDmOrgId(newDmOrgId: string | null) {
    this.newDmOrgId = newDmOrgId;
  }
  @Mutation
  setNewDmUserIds(newDmUserIds: string[]) {
    this.newDmUserIds = newDmUserIds;
  }

  @Mutation
  clearNewDmSelection() {
    this.newDmOrgId = null;
    this.newDmUserIds = [];
    this.chatWithTeamId = null;
    this.playerId = null;
  }

  @Action
  chatWithTeam(teamId: string) {
    this.context.commit("setChatWithTeamId", teamId);
    router.push({ name: Routes.CHAT.name });
  }

  @Action
  chatWithAdmins(orgUnit: any) {
    const id = orgUnit.isOrganization ? orgUnit.id : orgUnit.organizationId;
    this.context.commit("setNewDmOrgId", id);
    if (orgUnit.orgAdmins && orgUnit.orgAdmins.length > 0) {
      const admins = orgUnit.orgAdmins.map((admin: any) => admin.id);
      this.context.commit("setNewDmUserIds", admins);
    }
    router.push({ name: Routes.CHAT.name });
  }

  @Action
  chatWithPlayer({ playerId, orgId }: { playerId: string; orgId: string }) {
    this.context.commit("setPlayerId", playerId);
    this.context.commit("setNewDmOrgId", orgId);
    router.push({ name: Routes.CHAT.name });
  }
}
